import SimpleDate from 'app/common/classes/simple-date'

import { extractDateAndNameFromColumnKey } from './create-column-keys'
import { Entity } from './types'

export const headerCells = {
  [Entity.Title]: '',
  [Entity.Total]: 'Всего',
  [Entity.TotalCount]: 'Кол-во',
  [Entity.TotalSum]: 'Сумма',
  [Entity.DateCount]: 'Кол-во',
  [Entity.DateSum]: 'Сумма',
  [Entity.RowInternal]: 'Внутренний счет',
  [Entity.RowSbp]: 'СБП',
  [Entity.RowBankCard]: 'Банковская карта',
  [Entity.RowCash]: 'Наличные',
  [Entity.RowGrandTotal]: 'ИТОГО',
}

export const createHeaderCells = (
  currency: string,
  sourceDateFormat: string = 'YYYY-MM-DD',
  outputDateFormat: string = 'DD.MM.YYYY',
) => {
  return new Proxy(headerCells, {
    get: function (target, property) {
      if (property === Entity.TotalSum) return `${target[Entity.TotalSum]},\u00A0${currency}`
      const res = target[property]
      if (!res) {
        const [name, key] = extractDateAndNameFromColumnKey(property as string)
        if (name === Entity.DateCount) return target[Entity.DateCount]
        if (name === Entity.DateSum) return `${target[Entity.DateSum]},\u00A0${currency}`
        return new SimpleDate(key, sourceDateFormat).getStringFormatted(outputDateFormat)
      }
      return res || ''
    },
  })
}
